import { FC, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download"
import { crudGetList, ReduxState, useListContext } from "ra-core";
import { useDispatch, useSelector } from "react-redux";
import { pages, sorts } from "~/utils/paramsWithGetMainList";
import LoadingButton from "@mui/lab/LoadingButton";
import { useSnackbar } from "notistack";
import { Tooltip } from "@mui/material";

const ExportDataCatalogButton: FC = () => {
  const { filterValues } = useListContext()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [states, setStates] = useState({ count: 0, loading: false })
  const startExport = () => {
    setStates(s => ({...s, loading: true }))
    dispatch(crudGetList('govrnc-catalog-export', pages(), sorts(), {...filterValues, _count: states.count }))
  }

  useSelector<ReduxState, any>(store => {
    const data = store.admin.resources['govrnc-catalog-export']?.data[-1]
    if (states.loading && states.count === data?.count)
    {
      if (data?.errMsg) {
        enqueueSnackbar(`Failed to download export: ${data.errMsg}`, { variant: 'error' })
      }
      setStates(s => ({ loading: false, count: s.count + 1 }))
    }
  })
  return (
    <Tooltip title="Please adjust search criteria so that exported csv file contains less than 100,000 rows.">
      <LoadingButton
        color="primary"
        startIcon={<DownloadIcon fontSize="small" />}
        sx={{ ml: 'auto!important', mr: theme => `${theme.spacing(2)}!important` }}
        variant="text"
        loading={states.loading}
        loadingPosition="start"
        onClick={startExport}
      >
        Export
      </LoadingButton>
    </Tooltip>
  )
}

export default ExportDataCatalogButton;
